import React from 'react';
import { Box, Button, CircularProgress, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useTranslation } from 'react-i18next';
import { GetHelp, InfoButton } from '../FormWidgets/Description';

const useStyles = makeStyles((theme) => ({
  pending: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary
  }
}));

// Presentation only: each feature owns confirmation, recovery and scope.
export default function SettingsSaveNotice({ status, message, scope, helpId, onUseController, onKeep, keepDisabled }) {
  const { t } = useTranslation();
  const classes = useStyles();
  if (!status || status === 'confirmed') return null;
  const pending = status === 'pending';
  const help = GetHelp(helpId);
  return <Box mb={2}>
    <Alert severity={pending || status === 'review' ? 'info' : 'warning'}
      className={pending ? classes.pending : undefined}
      icon={pending ? <CircularProgress size={20} aria-label={t(message)} /> : undefined}>
      <Box display="flex" alignItems="center" flexWrap="wrap">
        <span>{scope ? `${t(scope)}: ` : ''}{t(message)}</span>
        <InfoButton content={help.content} ariaLabel={t(helpId)} />
      </Box>
      {!pending && status !== 'review' && onUseController && <Box display="flex" flexWrap="wrap" gridGap={8} mt={1}>
        <Button variant="outlined" color="primary" onClick={onUseController}>
          {t('settings_use_controller_settings')}
        </Button>
        <Button variant="outlined" color="primary" onClick={onKeep} disabled={keepDisabled}>
          {t('settings_keep_unsaved_settings')}
        </Button>
      </Box>}
    </Alert>
  </Box>;
}
